import img from "../../images/installation_paysage.jpg";
import "../../style/carouselPerView.css";
import { Card, CardHeader } from "../../components/ui/card";
import { Link } from "react-router-dom";

import supportImg from "../../images/icons/m1-1 (1).png";
import actImg from "../../images/icons/m2-1 (1).png";
import videoImg from "../../images/icons/m4-1- (1).png";
import photoImg from "../../images/icons/m5-1- (1).png";
import actesImg from "../../images/icons/m7-1- (1).png";
import statusImg from "../../images/icons/m8-1- (1).png";
import enqueteImg from "../../images/icons/m9-1- (1).png";
import { useEffect, useState } from "react";
import { getAllStatuts } from "../../API/Mediatheque/Statuts/statutsService";

const Mediatheque = () => {
  const CARDS = [
    { id: 1, icon: photoImg, url: "/mediatheque/photos", title: "Photos" },
    {
      id: 2,
      icon: videoImg,
      url: "/mediatheque/videos",
      title: "VIDÉOS",
    },
    {
      id: 3,
      icon: supportImg,
      url: "/mediatheque/support-communications",
      title: "SUPPORTS DE COMMUNICATION",
    },
    {
      id: 4,
      icon: actImg,
      url: "/mediatheque/rapport-activités",
      title: "RAPPORTS D’ACTIVITÉ",
    },

    {
      id: 7,
      icon: actesImg,
      url: "/mediatheque/actes-administratifs",
      title: "ACTES ADMINISTRATIFS",
    },
    {
      id: 7,
      icon: statusImg,
      url: "",
      title: "STATUTS",
    },
    {
      id: 8,
      icon: enqueteImg,
      url: "",
      title: "ENQUÊTES PUBLIQUES",
    },
  ];

  const [data, setData] = useState<any[]>([]);
   const fetchData = async () => {
    const response = await getAllStatuts();
    setData(response?.statuts);
  };
  useEffect(() => {
    fetchData();
  }, []);

 
  const openFile = (file: any) => {
     const uploadUrl = process.env.REACT_APP_FILE_UPLOAD;
    const fileUrl = `${uploadUrl}/medias/statuts/${encodeURIComponent(data?.[0]?.file)}`;

    window.open(fileUrl, "_blank");
  };
  return (
    <div className=" mb-52">
      <div className="">
        <section
          className="p-10 text-center lg:p-32 bg-black/70 bg-blend-overlay "
          style={{
            backgroundImage: `url(${img})`,
            backgroundSize: "cover",
            backgroundRepeat: "no-repeat",
            backgroundPosition: "center",
          }}
        >
          <h1 className="text-2xl font-bold text-center text-white md:text-4xl lg:text-7xl">
            {"Médiathèque"}
          </h1>

          <div className="flex justify-center mt-3">
            <p className="w-full text-white ">
              {"Toutes nos documentations à votre disposition"}
            </p>
          </div>
        </section>
      </div>

      <div className="container flex justify-center mx-auto mt-40 mb-20 md:px-40 sm:px-40">
        <div className="grid grid-rows-1 gap-5 lg:grid-cols-3">
          {CARDS.map((item) => (
            <div key={item.id} className="duration-200 group hover:scale-110">
              {item.title === "STATUTS" ? (
                // Call openFile when clicking "Statuts"
                <div
                  onClick={() => openFile("statuts.pdf")}
                  className="cursor-pointer"
                >
                  <Card className="w-full border rounded-lg border-primary group-hover:bg-bg_aquavesc">
                    <CardHeader className="w-full">
                      <div className="flex w-full">
                        <div className="flex items-center justify-center w-full m-3">
                          <img src={item.icon} alt="" className="w-[40px]" />
                        </div>
                        <div className="flex items-center w-full m-3 text-sm font-bold uppercase">
                          {item.title}
                        </div>
                      </div>
                    </CardHeader>
                  </Card>
                </div>
              ) : (
                // Use <Link> for other cards
                <Link to={item.url}>
                  <Card className="w-full border rounded-lg border-primary group-hover:bg-bg_aquavesc">
                    <CardHeader className="w-full">
                      <div className="flex w-full">
                        <div className="flex items-center justify-center w-full m-3">
                          <img src={item.icon} alt="" className="w-[40px]" />
                        </div>
                        <div className="flex items-center w-full m-3 text-sm font-bold uppercase">
                          {item.title}
                        </div>
                      </div>
                    </CardHeader>
                  </Card>
                </Link>
              )}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Mediatheque;
